// Synchronous flag used to mark fetch calls initiated by the polling loop.
// Safe because JS is single-threaded: the flag is set right before config.apiCall()
// returns its Promise (i.e. before the first internal `await`), so the
// getXStream functions read the flag synchronously while building headers.
let _polling = false;
export const setIsPollingRequest = (v: boolean) => { _polling = v; };
export const getIsPollingRequest = () => _polling;
